<template>
  <BuilderBtnItem
    icon="magic"
    title="Setup Wizard"
    :disabled="disabled"
    :icon-size="iconSize"
    @click="$bvModal.show('builder-wizard-modal')"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderBtnItem from '@/components/builder/BuilderNav/BuilderBtnItem.vue'

const components = {
  BuilderBtnItem,
}

const props = {
  disabled: Boolean,
  iconSize: {
    type: String,
    default: '',
  },
}

@Component({ components })
export default class BuilderNavWizard extends Vue.extend({ props }) {}

</script>
